import { Button, useCellValues, activeEditor$, useTranslation } from '@mdxeditor/editor';
import { $getSelection, $isRangeSelection, $createTextNode } from 'lexical';
import { $createLinkNode } from '@lexical/link';
import { useEffect, useState } from 'react';
import './InsertFile.css';
import { CircularProgress } from '@mui/material';

export const InsertFile = ({ uploadFile }: { uploadFile: (image: File) => Promise<string> }) => {
    const [file, setFile] = useState<File | undefined>(undefined);
    const [activeEditor] = useCellValues(activeEditor$);
    const t = useTranslation();
    const [showProgress, setShowProgress] = useState(false);

    useEffect(() => {
        const saveFileLink = async () => {
            if (activeEditor && file) {
                uploadFile(file).then((url) => {
                    setShowProgress(false);
                    activeEditor.update(() => {
                        const selection = $getSelection();
                        if ($isRangeSelection(selection)) {
                            const linkNode = $createLinkNode(url);
                            const textNode = $createTextNode(file.name);
                            linkNode.append(textNode);
                            selection.insertNodes([linkNode]);
                        }
                    });
                });
                setFile(undefined);
            }
        };
        if (file) {
            saveFileLink();
        }
    }, [file, uploadFile, activeEditor])

    return (
        <>
            {showProgress &&
                <div className='uploadProgress'>
                    <CircularProgress color='error' size={55} />
                </div>
            }
            <Button
                title={t('toolbar.file', 'Insert file')}
                style={{ position: 'relative' }}
            >   
                📎
                <input
                    style={{ position: 'absolute', opacity: 0, left: 0, right: 0, top: 0, bottom: 0 }}
                    type="file"
                    onChange={(e) => {
                        if (e.target.files) {

                            const reader = new FileReader();
                            const file = e.target.files[0];
                            reader.onloadend = () => {
                                setFile(file);
                            }

                            if (e.target.files[0]) {
                                setShowProgress(true);
                                reader.readAsDataURL(file);
                            }
                        }
                    }}
                />
            </Button>
        </>
    );
};